import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import sleep from 'sleep-promise';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';
import { loadData } from '../../../core/components/core/Util/List/CustomList/loadData';

function List() {
    const profileFilter = chooseProfileFilter();
    const pathFrontEnd = '/governanceroom/samuneighborhoods/';
    const paths = {
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpoint: `${config.endpoints.backend}governanceroom/samuneighborhoods/getall`,
        endpointStates: `${config.endpoints.backend}governanceroom/states/getall`,
        endpointCities: `${config.endpoints.backend}governanceroom/cities/getall`
    };

    const dispatch = useDispatch();
    const [filterValues, setFilterValues] = useState({
        geografic_state_id: '',
        city_id: '',
        linked: ''
    });

    const handleChange = async (element) => {
        const target = element['target'];
        let filters = { ...filterValues };

        // trocar o estado invalida o município escolhido
        if (target.name === 'geografic_state_id') {
            filters.city_id = '';
        }

        filters = { ...filters, [target['name']]: target['value'] };
        setFilterValues(filters);
        await sleep(500);
        dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
    };

    useEffect(() => {
        const reload = async () => {
            await sleep(500);
            dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
        };
        reload();
    }, [filterValues]);

    const filters = useMemo(() => ({
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        update_key: `${filterValues.geografic_state_id}-${filterValues.city_id}-${filterValues.linked}`,
        handleSubmit: loadData,
        fields: [
            {
                name: 'geografic_state_id',
                type: 'select',
                label: 'Estado',
                handleChange,
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointStates,
                    label: 'geografic_state_name',
                    value: 'geografic_state_id'
                },
                validations: { required: false },
                columnSize: 4
            },
            {
                name: 'city_id',
                type: 'select',
                label: 'Município',
                handleChange,
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointCities,
                    label: 'city_name',
                    value: 'city_id',
                    params: {
                        filter: {
                            where: {
                                geografic_state_id: filterValues.geografic_state_id,
                                profileFilter
                            }
                        }
                    }
                },
                validations: { required: false },
                columnSize: 4
            },
            {
                name: 'linked',
                type: 'select',
                label: 'Vinculado?',
                handleChange,
                options: [
                    { label: 'Todos', value: '' },
                    { label: 'Sim', value: '1' },
                    { label: 'Não', value: '0' }
                ],
                validations: { required: false },
                columnSize: 4
            }
        ],
        values: filterValues
    }), [filterValues]);

    const list = useMemo(() => ({
        labelTitle: 'Bairros SAMU',
        labelTitleButtonAdd: '',
        canAdd: false,
        canDelete: false,
        showPrintButtons: false,
        formFilters: filters,
        filter: { ...filterValues },
        columns: [
            {
                name: 'geografic_state_uf',
                label: 'Estado',
                width: '8%'
            },
            {
                name: 'city_name',
                label: 'Município',
                width: '22%'
            },
            {
                name: 'name',
                label: 'Bairro SAMU',
                width: '25%'
            },
            {
                name: 'neighborhood_name',
                label: 'Bairro',
                width: '25%'
            },
            {
                name: 'linked',
                label: 'Vinculado?',
                width: '10%'
            }
        ],
        ...paths
    }), [filters, filterValues]);

    const content = useMemo(() => <CustomList list={list} />, [list]);

    return (
        <div>
            <CustomListContainer
                canAdd={false}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd=""
                content={content}
            />
        </div>
    );
}

export default List;
